import { throttle } from 'throttle-debounce';

/** Selector for any instance of this _Friendation_ component */
const heroSelector = '[is^="hero-media"]';

/**
 * Friendation component
 */
export const heroCtaElements = () => {
  /** Instances of this Friendation component */
  const heroComponents: HTMLElement[] = Array.from(
    document.querySelectorAll(heroSelector)
  );

  /** Breakpoint Mobile/Desktop navigation */
  const breakpointHeader = 1280;

  const component: HTMLElement = document.querySelector(
    "[is='hero-cta-elements']"
  );
  if (!component) return;

  heroComponents.forEach((heroComponent) => {
    /**
     * The cta elements ({@link component}) are outside of the {@link heroComponent} which makes relative positioning a bit more complicated. That is why this function exists.
     */
    const handleCtaElements = () => {
      const update = throttle(100, () => {
        requestAnimationFrame(() => {
          const heroHeight: number =
            heroComponent.getBoundingClientRect().height;

          if (
            window.scrollY > heroHeight * 0.5 &&
            window.innerWidth >= breakpointHeader
          ) {
            // set to small after some distance was scrolled (desktop only)
            component.classList.add('small-cta');
          } else {
            // reset
            component.classList.remove('small-cta');
          }
        });
      });

      window.addEventListener('scroll', update.bind(this));
      window.addEventListener('resize', update.bind(this));
      update();
    };

    /**
     * On mobile we display the cta elements inside {@link basisNavigationMobile} – so we move it from the desktop container {@link targetContainerDesktop} to the mobile container {@link targetContainerMobile} (and back) on resize.
     */
    const handleMobile = () => {
      /** Mobile navigation */
      const basisNavigationMobile = document.querySelector(
        '[is="basis-navigation-mobile"]'
      );
      if (!basisNavigationMobile) return;

      /** The element that contains the {@link component} on mobile */
      const targetContainerMobile: HTMLElement =
        basisNavigationMobile.querySelector('.mobile-footer .bottom');
      if (!targetContainerMobile) return;

      /** The element that contains the {@link component} on desktop (where „contains” means prepend in this context) */
      const targetContainerDesktop: HTMLElement = heroComponent;
      if (!targetContainerDesktop) return;

      const onTick = throttle(100, () => {
        if (window.innerWidth >= breakpointHeader) {
          // Desktop (move only if not already moved)
          if (targetContainerMobile.contains(component))
            heroComponent.prepend(component);
        } else {
          // Mobile (move only if not already moved)
          if (!targetContainerMobile.contains(component))
            targetContainerMobile.append(component);
        }
      });

      window.addEventListener('resize', onTick.bind(this));
      onTick();
    };

    handleCtaElements();
    handleMobile();
  });
};
